var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.state)?_c('a-tag',{staticStyle:{"width":"58px"},attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.$t(`service_busyness_type.${_vm.state}`)))]):_c('a-tag',{staticStyle:{"width":"58px"},attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.score)+"分")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }